import { css } from '@emotion/react'
import { uaRed } from '../../../style/colors'

export const styleHoverDeleteIcon = css`
  :hover > div {
    background-color: ${uaRed['500']};
  }
`
